import React, { useState, useEffect } from 'react'
import styled from 'styled-components'

type BarPosition = 'top' | 'bottom'
type Props = {
  isVisible?: boolean
  postion?: BarPosition
}

const StickyBar: React.FC<Props> = ({ isVisible = true, postion = 'bottom', children }) => {
  const barRef = React.useRef<HTMLDivElement>(null)
  const [parentWidth, setParentWidth] = useState(0)

  useEffect(() => {
    if (barRef.current) {
      setParentWidth(barRef.current?.parentElement?.offsetWidth || 0)
    }
  }, [barRef.current?.parentElement?.offsetWidth])

  return (
    <div ref={barRef}>
      <Bar isVisible={isVisible} position={postion} width={parentWidth}>
        {children}
      </Bar>
    </div>
  )
}

const Bar = styled.div<{ isVisible: boolean; position: BarPosition; width: number }>`
  box-sizing: border-box;
  background-color: ${(p) => p.theme.colors.white};
  width: ${(p) => p.width}px;
  position: fixed;
  ${(p) => p.position === 'top' && `top: 0;`}
  ${(p) => p.position === 'bottom' && `bottom: 0;`}
  border-top: 1px solid ${(p) => p.theme.colors.defaultBorder};
  padding: 10px 100px 10px 10px;
  display: ${(p) => (p.isVisible ? `flex` : `none`)};
  justify-content: flex-end;
`

export default StickyBar
